<template>
  <div class="sb" :class="{ 'sb-compact': compact }">
    <div class="sb-head" v-if="!compact">
      <div class="sb-avatar"><i class="fa fa-magic"></i></div>
      <div class="sb-head-text">
        <strong>المساعد الذكي</strong>
        <small>إجابات فورية عن النظام · قد يخطئ أحياناً</small>
      </div>
      <button v-if="messages.length" type="button" class="sb-new" @click="reset">
        <i class="fa fa-refresh"></i> محادثة جديدة
      </button>
    </div>

    <div class="sb-body" ref="body">
      <div v-if="!messages.length" class="sb-welcome">
        <div class="sb-welcome-title">أهلاً بك! أنا المساعد الذكي</div>
        <div class="sb-welcome-text">اسألني عن أي خدمة في التحضير الذكي وسأجيبك فوراً. لمشكلة عاجلة استخدم «الدعم الفني السريع».</div>
        <div v-if="suggestions.length" class="sb-chips-title">أسئلة شائعة</div>
        <div class="sb-chips">
          <button v-for="s in suggestions" :key="s" type="button" class="sb-chip" @click="ask(s)">{{ s }}</button>
        </div>
      </div>

      <div v-for="(m, i) in messages" :key="i" class="sb-row" :class="m.role == 'user' ? 'sb-row-user' : 'sb-row-bot'">
        <div class="sb-bubble" :class="{ 'sb-bubble-user': m.role == 'user', 'sb-bubble-error': m.error }">
          <span class="sb-text">{{ m.text }}</span>
          <button v-if="m.error && m.retry" type="button" class="sb-retry" @click="retry(i)">
            <i class="fa fa-repeat"></i> إعادة المحاولة
          </button>
        </div>
      </div>

      <div v-if="busy" class="sb-row sb-row-bot">
        <div class="sb-bubble sb-typing" aria-label="المساعد يكتب">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <button v-if="answered" type="button" class="sb-escalate" :class="{ 'sb-escalate-hot': suggestTicket }" @click="escalate">
      <i class="fa fa-bolt"></i>
      <span><strong>لم تجد الحل؟</strong> افتح تذكرة دعم سريع</span>
      <i class="fa fa-angle-left sb-escalate-arrow"></i>
    </button>

    <form class="sb-compose" @submit.prevent="send">
      <textarea ref="input" v-model="input" class="sb-input" rows="1" maxlength="600" placeholder="اكتب سؤالك…"
                :disabled="busy" aria-label="اكتب سؤالك" @keydown="key"></textarea>
      <button type="submit" class="sb-send" :disabled="busy || !input.trim()" aria-label="إرسال">
        <i class="fa fa-paper-plane" style="transform: scaleX(-1)"></i>
      </button>
    </form>
  </div>
</template>

<script>
import { call } from './support-api';

// The AI assistant of /user/support/bot, shared by the contact page and the floating «الدعم الفني»
// button. Sends only the last 3 exchanges (300 characters each), like the school app.
export default {
  props: {
    compact: { type: Boolean, default: false },
  },
  data(){
    return { messages: [], suggestions: [], input: '', busy: false, suggestTicket: false };
  },
  computed: {
    answered(){ return this.messages.some(function(m){ return m.role == 'assistant' && !m.error; }); },
    lastQuestion(){
      for (var i = this.messages.length - 1; i >= 0; i--) if (this.messages[i].role == 'user') return this.messages[i].text;
      return '';
    },
  },
  created(){
    var g = this;
    call('/bot/suggestions').then(function(r){ if (r.ok && Array.isArray(r.data)) g.suggestions = r.data.slice(0, 6); });
  },
  methods: {
    key(e){
      if (e.key == 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); this.send(); }
    },
    send(){
      var q = this.input.trim();
      if (!q || this.busy) return;
      this.input = '';
      this.ask(q);
    },
    history(){
      // the exchanges before the new question, without failed answers
      var ok = this.messages.filter(function(m){ return !m.error; }).slice(-6);
      return ok.map(function(m){ return { role: m.role, text: (m.text || '').slice(0, 300) }; });
    },
    ask(q){
      var g = this;
      var history = g.history();
      g.messages.push({ role: 'user', text: q });
      g.busy = true;
      g.scroll();
      call('/bot', { message: q, history: JSON.stringify(history) }).then(function(r){
        g.busy = false;
        if (r.ok && r.data && r.data.reply) {
          g.messages.push({ role: 'assistant', text: r.data.reply });
          g.suggestTicket = !!r.data.suggest_ticket;
        } else {
          g.messages.push({ role: 'assistant', text: r.message || 'لم يتمكن المساعد من الرد الآن، حاول مرة أخرى', error: true, retry: q });
        }
        g.scroll();
      });
    },
    retry(i){
      var q = this.messages[i].retry;
      // drop the failed answer and its question, then ask again
      this.messages.splice(i - 1, 2);
      this.ask(q);
    },
    reset(){
      this.messages = [];
      this.suggestTicket = false;
      this.input = '';
    },
    escalate(){
      this.$emit('urgent', this.lastQuestion);
    },
    scroll(){
      var g = this;
      g.$nextTick(function(){ var b = g.$refs.body; if (b) b.scrollTop = b.scrollHeight; });
    },
  },
};
</script>

<style scoped>
.sb { display: flex; flex-direction: column; min-height: 0; height: 520px; }
.sb-compact { height: 100%; }
.sb-head { display: flex; align-items: center; gap: 12px; padding-bottom: 12px; border-bottom: 1px solid rgba(127, 127, 127, 0.16); }
.sb-avatar {
  width: 42px; height: 42px; border-radius: 13px; flex: 0 0 auto; display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, #4f46e5, #2563eb); color: #fff; font-size: 18px;
}
.sb-head-text { display: flex; flex-direction: column; min-width: 0; flex: 1; }
.sb-head-text small { opacity: 0.7; }
.sb-new { border: 0; background: transparent; color: var(--primary); font-weight: 600; cursor: pointer; padding: 6px 8px; border-radius: 8px; }
.sb-new:hover { background: rgba(127, 127, 127, 0.08); }

.sb-body { flex: 1; min-height: 0; overflow-y: auto; padding: 14px 2px; display: flex; flex-direction: column; gap: 10px; }
.sb-welcome { padding: 6px 2px 4px; }
.sb-welcome-title { font-weight: 700; font-size: 16px; margin-bottom: 4px; }
.sb-welcome-text { opacity: 0.75; line-height: 1.8; }
.sb-chips-title { margin: 14px 0 8px; font-weight: 600; font-size: 13px; opacity: 0.8; }
.sb-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.sb-chip {
  border: 1px solid rgba(37, 99, 235, 0.35); background: rgba(37, 99, 235, 0.06); color: var(--primary);
  border-radius: 999px; padding: 7px 13px; font-size: 13px; cursor: pointer; text-align: start; line-height: 1.6;
}
.sb-chip:hover { background: rgba(37, 99, 235, 0.12); }

.sb-row { display: flex; }
.sb-row-user { justify-content: flex-start; }
.sb-row-bot { justify-content: flex-end; }
.sb-bubble {
  max-width: 86%; padding: 10px 14px; border-radius: 16px; line-height: 1.85; white-space: pre-wrap; overflow-wrap: anywhere;
  background: rgba(127, 127, 127, 0.1);
}
.sb-bubble-user { background: var(--primary); color: #fff; }
.sb-bubble-error { background: rgba(234, 84, 85, 0.1); color: #c62828; }
.sb-retry { display: block; margin-top: 6px; border: 0; background: transparent; color: inherit; font-weight: 700; cursor: pointer; padding: 0; }
.sb-typing { display: inline-flex; gap: 5px; align-items: center; padding: 14px 16px; }
.sb-typing span { width: 7px; height: 7px; border-radius: 50%; background: currentColor; opacity: 0.35; animation: sb-dot 1.2s infinite ease-in-out; }
.sb-typing span:nth-child(2) { animation-delay: 0.15s; }
.sb-typing span:nth-child(3) { animation-delay: 0.3s; }
@keyframes sb-dot { 0%, 80%, 100% { opacity: 0.25; transform: translateY(0); } 40% { opacity: 0.8; transform: translateY(-3px); } }
@media (prefers-reduced-motion: reduce) { .sb-typing span { animation: none; } }

.sb-escalate {
  display: flex; align-items: center; gap: 10px; width: 100%; margin: 4px 0 10px; padding: 10px 14px;
  border-radius: 12px; border: 1px solid rgba(234, 84, 85, 0.25); background: rgba(234, 84, 85, 0.05);
  color: #c62828; cursor: pointer; text-align: start;
}
.sb-escalate span { flex: 1; }
.sb-escalate-hot { background: #ea5455; border-color: #ea5455; color: #fff; }
.sb-escalate-arrow { font-size: 18px; }

.sb-compose { display: flex; gap: 8px; align-items: flex-end; }
.sb-input {
  flex: 1; min-width: 0; resize: none; max-height: 120px; border-radius: 12px; padding: 10px 12px; line-height: 1.6;
  border: 1px solid rgba(127, 127, 127, 0.3); background: transparent; color: inherit; font: inherit;
}
.sb-input:focus { outline: 2px solid rgba(37, 99, 235, 0.35); border-color: var(--primary); }
.sb-send {
  width: 44px; height: 44px; flex: 0 0 auto; border: 0; border-radius: 12px; background: var(--primary); color: #fff; cursor: pointer;
}
.sb-send:disabled { opacity: 0.45; cursor: not-allowed; }
</style>
